module.exports ={
    abrirJanelaVideo: 'Abrir janela de vídeo',
    administradores: 'Administradores',
    administradoresAdicionados: 'Administradores adicionados',
    agenda: 'Agenda',
    agendamento: 'Agendamento',
    agendamentoCancelado: 'Agendamento cancelado com sucesso.',
    agendamentoEncerrado: 'Agendamento encerrado com sucesso.',
    agendamentosConsulta: 'Agendamentos de consultas',
    agendamentosPassados: 'Agendamentos passados',
    agendar: 'Agendar',
    aguardeSalaVideo: 'Aguarde enquanto configuramos a sala de atendimento...',
    alteracaoArea: 'Alteração de área',
    alteracaoMotivoCancelamento: 'Alteração de motivo de cancelamento',
    alteracaoMotivoEncerramento: 'Alteração de motivo de encerramento',
    anexar: 'Anexar',
    anexarArquivo: 'Anexar arquivos',
    anexos: 'Anexos',
    area: 'Área',
    areaAdicionada: 'Área adicionada com sucesso.',
    areas: 'Áreas',
    areasAdicionadas: 'Áreas adicionadas',
    atendenteAdicionado: 'Atendente adicionado com sucesso.',
    atendentes: 'Atendentes',
    atendentesAdicionados: 'Atendentes adicionados',
    atendimento: 'Atendimento',
    atendimentoMes: 'Atendimentos do mês',
    atendimentos: 'Atendimentos',
    atendimentoSemAgendamento: 'Aceita atendimentos sem agendamento?',
    atendimentoSemana: 'Atendimentos da semana',
    avisoSemConexao: 'Ops! Parece que perdemos a conexão com o servidor de Teleatendimento. Verifique sua conexão com a internet e aguarde, o sistema será recarregado automaticamente assim que a conexão for restabelecida. Se preferir, você pode recarregar manualmente clicando <a href="javascript:window.location.reload(true)"><b>aqui</b></a>.',
    cadastrarMensagem: 'Cadastrar mensagem',
    cadastroArea: 'Cadastro de área',
    cadastroMotivoCancelamento: 'Cadastro de motivo de cancelamento',
    cadastroMotivoEncerramento: 'Cadastro de motivo de encerramento',
    calendario: 'Calendário',
    cancelarAgendamento: 'Cancelar agendamento',
    chamadaVideo: 'Iniciar atendimento por vídeo',
    chat: 'Chat',
    cnesConsultorioDesabilitado: cnes => `A instituição com o CNES número ${cnes} não possui um consultório virtual habilitado.`,
    cnesInvalido: cnes => `A instituição com o CNES número ${cnes} não existe.`,
    comparando: 'Comparando',
    complementacoes: 'Complementações',
    concluido: 'Concluído',
    concordo: 'Concordo',
    configuracaoConsultorio: 'Configuração do consultório virtual',
    confirmarAgendamento: 'Você tem certeza que deseja agendar este atendimento?',
    confirmarCancelarAgendamento: 'Você tem certeza que deseja cancelar este agendamento?',
    confirmarEncerrarAgendamento: 'Você tem certeza que deseja encerrar este agendamento?',
    confirmarFinalizarAtendimento: 'Você tem certeza que deseja finalizar este atendimento?',
    confirmarLiberarAtendente: nome => `O atendente "${nome}" está solicitando acesso a este atendimento. Você libera o acesso?`,
    confirmarRegistroAtendimento: 'Você tem certeza que deseja salvar esse registro de atendimento?',
    confirmarInvalidacaoAssinatura: 'Este registro já foi assinado digitalmente. Qualquer alteração irá invalidar a assinatura atual, sendo necessário assinar novamente. Você deseja continuar?',
    confirmarSalvarArea: 'Você tem certeza que deseja salvar esta área?',
    confirmarSalvarConsultorio: 'Você tem certeza que deseja salvar estas configurações do consultório?',
    confirmarSalvarMotivoDeCancelamento: 'Você tem certeza que deseja salvar este motivo de cancelamento?',
    confirmarSalvarMotivoDeEncerramento: 'Você tem certeza que deseja salvar este motivo de encerramento?',
    confirmarSalvarRespostaRapida: 'Deseja salvar essa resposta rápida?',
    consultorioVirtual: 'Consultório virtual',
    dadosGerais: 'Dados Gerais',
    dataHoraInicio: 'Data/hora de início',
    descricao: 'Descrição',
    desfecho: 'Desfecho',
    desfechoAtendimento: 'Desfecho do atendimento',
    digiteMensagem: 'Digite sua mensagem...',
    encaminhando: 'Encaminhando...',
    encaminharAtendimento: 'Encaminhar atendimento',
    encerrar: 'Encerrar',
    encerrarAgendamento: 'Encerrar agendamento',
    enviandoArquivo: 'Enviando arquivo...',
    enviarMensagem: 'Enviar mensagem',
    erroAreaDuplicada: 'Área já adicionada anteriormente.',
    erroAtendenteDuplicado: 'Atendente já adicionado anteriormente.',
    erroAtendenteObrigatorio: 'Selecione pelo menos um atendente.',
    erroCarregarDadosConsultorio: 'Erro ao carregar os dados do consultório para alteração. Por favor, tente novamente.',
    erroConectarBBB: 'Erro ao conectar na sala de áudio e vídeo. Deseja tentar novamente?',
    erroMinimoArea: 'Adicione pelo menos uma área.',
    espera: 'Em espera',
    fecharAtendimento: 'Fechar janela de atendimento',
    fecharChamadaVideo: 'Fechar atendimento por vídeo',
    fecharHistorico: 'Fechar histórico',
    finalizarAtendimento: 'Finalizar atendimento',
    historico: 'Histórico',
    historicoAtendimento: 'Histórico dos atendimentos',
    historicoSaude: 'Histórico de saúde',
    habilitarImpressaoAssinatura: 'Habilitar impressão e assinatura digital do registro?',
    inserirAnexo: 'Inserir anexo',
    menuAtendimento: 'Atendimento',
    motivoAtendimento: 'Motivo do atendimento',
    motivoCancelamento: 'Motivo de cancelamento',
    motivoEncerramento: 'Motivo do encerramento',
    nenhumaMensagemEnviadaAtendimento: 'Nenhuma mensagem de texto foi enviada neste atendimento.',
    nenhumAnexoEnviadaAtendimento: 'Nenhum anexo foi enviado neste atendimento.',
    nenhumRegistroAtendimento: 'Nenhum registro foi enviado neste atendimento.',
    notificacaoHorarioConflito: 'Verificamos que o horário selecionado já está agendado para outro paciente e/ou atendente(s).',
    notificacaoNovaMensagemAnexo: 'Envio um anexo.',
    notificacaoNovoAtendimento: 'Você já está realizando um atendimento neste momento. Se você iniciar um novo atendimento ou visualizar as mensagens de outro atendimento, o atual será finalizado. Você confirma esta ação?',
    notificacaoSolicitacaoAtendimento: 'Um usuário solicitou atendimento.',
    notificacaoTabNovaMensagem: '✉️ Nova mensagem enviada',
    notificacaoTabSolicitacaoAtendimento: '🟠 Atendimento solicitado',
    novoAgendamento: 'Novo agendamento',
    outrasRespostas: 'Outras respostas',
    periodo: 'Período',
    pesquisaAreas: 'Pesquisa de áreas',
    pesquisaConsultorio: 'Pesquisa de consultório virtual',
    pesquisaMotivoCancelamento: 'Pesquisa de motivo de cancelamento',
    pesquisaMotivoEncerramento: 'Pesquisa de motivo de encerramento',
    pesquisaRespostas: 'Pesquisa de respostas',
    placeholderDesfechoAtendimento: 'Descrever as orientações que foram realizadas em relação ao manejo do caso apresentado, como as prescrições, solicitações de exames laboratoriais ou de imagem, orientações ao paciente ou ainda sobre a necessidade de retorno do atendimento.',
    placeholderHistoricoSaude: 'Descrever hábitos e comorbidades do paciente que possam influenciar suas condições de saúde, além de internações, cirurgias e tratamentos anteriores que sejam pertinentes ao caso.',
    placeholderMotivoAtendimento: 'Descreva o motivo para realização do atendimento.',
    placeholderRelatoCaso: 'Descrever o caso com clareza, apontando a história clínica atual de forma detalhada.',
    placeholderResultadoExames: 'Listar os resultados dos exames laboratoriais e de imagem que contribuam com a análise do caso.',
    placeholderTratamentosAndamento: 'Listar medicamentos e tratamentos alternativos em uso.',
    proximosAgendamentos: 'Próximos agendamentos',
    reagendar: 'Reagendar',
    registroAtendimento: 'Registro do atendimento',
    registroAtendimentoSalvoSucesso: 'Registro de atendimento salvo com sucesso.',
    registros: 'Registros',
    relatoCaso: 'Relato do caso',
    relatosPaciente: 'Relatos do paciente',
    resposta: 'Resposta',
    respostaRapida: 'Resposta rápida',
    respostas: 'Respostas',
    respostasRapidas: 'Respostas rápidas',
    resultados: 'Resultados de exames',
    resultadosExames: 'Resultados de exames laboratoriais ou de imagem',
    selecionarEmoji: 'Selecionar emoji',
    selecioneArquivo: 'Selecione um arquivo',
    selecioneInstituicao: 'Instituição para atendimento',
    selecioneUsuario: 'Selecione um usuário para iniciar ou continuar um atendimento.',
    semanaAnterior: 'semana anterior',
    semanaAtual: 'semana atual',
    semAtendenteEncaminhar: 'Não há outros atendentes disponíveis para encaminhar o atendimento.',
    solicitarAtendimento: 'Solicitar atendimento',
    somenteImagens: 'Somente imagens podem ser coladas diretamente no chat. Para arquivos de outros formatos, use a opção de anexar manualmente.',
    somenteUmaImagem: 'Somente uma imagem por vez pode ser colada diretamente no chat.',
    suporte: 'Suporte',
    teleatendimento: 'Teleatendimento',
    tempoAcessoAntecipado: 'Tempo de acesso antecipado (em minutos)',
    tempoAcessoMaximo: 'O tempo máximo de acesso antecipado permitido é de 240 minutos (4 horas).',
    tempoAcessoMinimo: 'O tempo mínimo de acesso antecipado permitido é de 1 minuto.',
    tempoDuracaoMinutos: 'Duração (em minutos)',
    termo: 'Termo de consentimento',
    textoAguarde: nome => `Olá, ${nome}!`,
    textoAguardeAtendimento: 'Aguarde seu atendimento.',
    textoAguardeSemAtendentes: 'No momento não há atendentes.',
    textoAtendenteConectado: 'Atendente conectado, por favor retire sua dúvida.',
    textoAtendimentoFinalizado: 'O atendente encerrou este atendimento.',
    textoCliqueAbrirHistorico: 'Verifique seu histórico <a href="javascript:void(0)"><b>aqui</b></a>.',
    textoCliqueSolicitarAtendimento: 'Solicite seu atendimento <a href="javascript:void(0)"><b>aqui</b></a>.',
    todosConsultorios: 'Todos Consultórios',
    tratamentosAndamento: 'Tratamentos em andamento',
    validar: 'Validar',
    vs: 'vs',
}

